/* eslint-disable no-use-before-define */
/* eslint-disable @typescript-eslint/no-explicit-any */
import React, { createContext } from 'react';

interface IBootStrapArgs {
  readonly app: React.ComponentType<any>;
  readonly elementRoot: HTMLElement;
}

export interface IContextRootValue {
  // prevents recursive dependencies when bootStrap is imported
  readonly bootStrap: <T1 extends IBootStrapArgs = IBootStrapArgs>(
    x: T1
  ) => void;
}

export const ContextRoot = createContext<{
  // prevents recursive dependencies when bootStrap is imported
  readonly bootStrap: <T1 extends IBootStrapArgs = IBootStrapArgs>(
    x: T1
  ) => void;
}>({
  bootStrap: undefined as any,
});
